import gql from "graphql-tag";

export const UPDATE_WORKSPACE_RATE = gql`
  mutation updateWorkspaceRate($input: updateWorkspaceRateInput) {
    updateWorkspaceRate(input: $input) {
      _id
    }
  }
`;
